import { ISlide } from '@/components/Slider/index';

export const defaultSlides: ISlide[] = [
  {
    id: 0,
    name: 'Сергей',
    company: 'АО «Биланлия», прокат автомобилей',
    carsCount: 180,
    cityCount: 37,
    text: 'Пользуемся сервисом FIT FLEET около года. Могу отметить удобство онлайн записи и возможность дистанционно контролировать все ремонты с мобильного телефона. Также все закрывающие документы приходят в ЭДО - это очень удобно!'
  },
  {
    id: 1,
    name: 'Александр',
    company: 'ООО «Ромфарма», фармацевтика',
    carsCount: 130,
    cityCount: 50,
    text: 'Онлайн запись, огромная сеть СТО в РФ. Можно согласовать запчасти любого ценового сегмента. Оперативность в согласовании и ремонте. Мне очень удобно работать с данной программой.'
  },
  {
    id: 2,
    name: 'Александр',
    company: 'ООО «Фронери», производство продуктов питания',
    carsCount: 126,
    cityCount: 32,
    text: 'Сотрудничаем полтора года. Удобно, оперативно, всегда есть варианты по цене запчастей, документы в ЭДО. Отдельно отмечу персональных менеджеров - на связи 24/7, всегда быстро помогут решить любую проблему. Плюс единая гарантия на все работы, что очень удобно, машина не привязана к станции.'
  },
  {
    id: 3,
    name: 'Дмитрий',
    company: 'ООО «Стартранс», услуги для автопарков',
    carsCount: 23,
    cityCount: 9,
    text: 'Давно работаем, всё классно! В нашем бизнесе главное - отсутствие простоев, FIT FLEET с этим легко справляется. Так как процениваем стоимость работ заранее, станция привозит запчасти и мы заезжаем на ремонт. Очень удобно! Также круто, что водители могут сами записываться на станцию, а я лишь согласовываю ремонт, для меня это снятие операционной нагрузки. Удобно, что есть отсрочка платежа, постоплата и НДС, естественно. Желаю только роста и развития!'
  },
  {
    id: 4,
    name: 'Владимир',
    company: 'ООО «Фармсервис», фармацевтика',
    carsCount: 54,
    cityCount: 27,
    text: 'Для нас автомобиль - инструмент в работе, он не должен простаивать - это убытки. FIT SERVICE отвечает всем нашим требованиям - НДС, ЭДО, большая сеть по стране, онлайн запись, широкий спектр услуг и единая гарантия. Хочу пожелать успехов нашему партнёру и сказать спасибо, что помогаете нам экономить на ремонте автомобилей.'
  },
  {
    id: 5,
    name: 'Михаил',
    company: 'ООО «Комплексные решения», услуги для автопарков',
    carsCount: 75,
    cityCount: 37,
    text: 'Очень удобно, что в FIT SERVICE можно обслуживать не только легковые машины, но и мелкую коммерцию - Газели, Транзиты, Джамперы и т.д. Станции компетентны в ремонте двигателей и КПП. Доверяем им свой парк по всей стране. Уверены в FIT SERVICE как в надёжном партнёре.'
  },
  {
    id: 6,
    name: 'Андрей',
    company: 'ООО «Лофтис», услуги для автопарков',
    carsCount: 116,
    cityCount: 19,
    text: [
      'Настоящим письмом компания ООО «Лофтис» сообщает, что за время сотрудничества с ООО «ФИТ Автосервис» данная компания успела себя зарекомендовать себя как профессиональный и надежный партнер. Отличительной чертой работы ООО «ФИТ Автосервис» является оперативность и высокая организованность сотрудников организации, готовность быстро реагировать на обстоятельства.',
      'Исходя из вышесказанного, компания ООО «Лофтис» хотела бы отметить высокий потенциал компании ООО «ФИТ Автосервис», нацеленность на дальнейшее успешное развитие и процветание.'
    ]
  },
  {
    id: 7,
    name: 'Филип Морис Сейлз Энд Маркетинг',
    company: 'Табачные изделия',
    carsCount: 147,
    cityCount: 39,
    link: {
      name: 'Благодарственное письмо',
      url: 'document.pdf',
      type: 'PDF'
    }
  }
];
